import React from 'react';
import { RefreshCw, ChevronDown } from 'lucide-react';

interface PullToRefreshProps {
  isPulling: boolean;
  isRefreshing: boolean;
  pullDistance: number;
  progress: number;
  shouldTrigger: boolean;
}

export const PullToRefreshIndicator: React.FC<PullToRefreshProps> = ({
  isPulling,
  isRefreshing,
  pullDistance,
  progress,
  shouldTrigger,
}) => {
  if (!isPulling && !isRefreshing) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 flex items-center justify-center z-50 transition-all duration-300"
      style={{
        transform: `translateY(${isRefreshing ? 60 : pullDistance}px)`,
        opacity: isPulling || isRefreshing ? 1 : 0,
      }}
    >
      <div className="bg-white rounded-full shadow-lg p-3">
        {isRefreshing ? (
          <RefreshCw className="w-6 h-6 text-slate-900 animate-spin" />
        ) : (
          <div className="relative">
            <ChevronDown
              className={`w-6 h-6 text-slate-900 transition-transform duration-300 ${
                shouldTrigger ? 'rotate-180' : ''
              }`}
            />
            <svg className="absolute inset-0 -rotate-90" width="32" height="32">
              <circle
                cx="16"
                cy="16"
                r="14"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                className="text-slate-200"
              />
              <circle
                cx="16"
                cy="16"
                r="14"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeDasharray="87.96"
                strokeDashoffset={87.96 - (87.96 * progress) / 100}
                className="text-slate-900 transition-all duration-150"
                strokeLinecap="round"
              />
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};
